import {premiums} from './premiums';

const superlikes = [
    {identifier: 'one_superlike_v1', fancyName: '1 суперлайк', price: 49, starsPrice: 50},
    {identifier: 'five_superlikes_v1', fancyName: '5 суперлайков', price: 149, starsPrice: 150},
];

export const products = [
    ...premiums.map((premium) => ({...premium, productType: 'premium'})),
    ...superlikes.map((superlike) => ({
        ...superlike,
        productType: 'superlike',
        getFancyPrice() {
            return `${this.price} ₽ / ${this.starsPrice} ⭐`;
        },
    })),
];

export const getProduct = (productId) => products.find((product) => product.identifier === productId);

const SUPERLIKE_PAYMENT_METHODS = ['antilopay', 'crypto', 'stars'];

export const isPaymentMethodAvailable = (product, method) =>
    product.productType === 'premium' || SUPERLIKE_PAYMENT_METHODS.includes(method);
